import { Component } from '@angular/core';
import { OrgChartMessages } from '../org-chart.messages';

@Component({
  selector: 'app-org-chart-restricted',
  templateUrl: './org-chart-restricted.component.html'
})
export class OrgChartRestrictedComponent {

  protected readonly eOrgChartMessages = OrgChartMessages;
}
